import React from 'react'
import { ITotalInfo } from '../pages/DashboardScreen/Dashboard'

const TotalInfoCard = ({ title, value, icon, iconBgColor, divBgColor }: ITotalInfo) => {

    return (
        <div className='p-4 rounded-lg flex flex-col gap-4' style={{ backgroundColor: divBgColor }}>
            <div className='flex w-fit items-center justify-center p-2 text-3xl text-white rounded-lg' style={{ backgroundColor: iconBgColor }}>
                {icon}
            </div>
            <div className='text-xl font-bold text-text_1'>{value}</div>
            <div className='text-xl font-bold text-text_1'>{title}</div>
        </div>
    )
}

export default TotalInfoCard